import FiltersContent from './FiltersContent';

export default FiltersContent;
